import { render, staticRenderFns } from "./Page-tinymce.vue?vue&type=template&id=dee7f096"
import script from "./Page-tinymce.vue?vue&type=script&lang=js"
export * from "./Page-tinymce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports